import type { ReactStoryblokComponent } from "types/storyblok";
import { PressCoverageItem } from "modules/storyblok/components/PressItem/PressCoverageItem";
import type { PressItemProps } from "modules/storyblok/components/PressItem";

const PressCoverageItemAdapter = ({
  blok: { href, image, title },
  sbEditable,
}: ReactStoryblokComponent<PressItemProps>) => (
  <PressCoverageItem href={href} image={image} title={title} sbEditable={sbEditable} />
);

export default PressCoverageItemAdapter;
